import axios from "axios";
import { environment } from "../../config/environment";

// Base URL for the chatbot FastAPI backend.
// In dev: http://localhost:8095
// In prod: set chatbotApiUrl in the appropriate environment file.
// const CHATBOT_BASE = environment.chatbotApiUrl || 'http://localhost:8095';
const CHATBOT_BASE = environment.apiUrl;

const chatbotAxios = axios.create({
  baseURL: CHATBOT_BASE,
  headers: { "Content-Type": "application/json" },
});

// Attach the current user's JWT and role/user headers before every request.
chatbotAxios.interceptors.request.use((config) => {
  const token =
    typeof window !== "undefined" ? localStorage.getItem("bgc_token") : null;
  let role =
    typeof window !== "undefined" ? localStorage.getItem("user_role") : null;
  const email =
    typeof window !== "undefined"
      ? localStorage.getItem("user_email") ||
        localStorage.getItem("email") ||
        ""
      : "";
  const userName =
    typeof window !== "undefined"
      ? localStorage.getItem("user_name") ||
        localStorage.getItem("username") ||
        ""
      : "";

  const pathname =
    typeof window !== "undefined" && window.location
      ? window.location.pathname
      : "";
  if (pathname.startsWith("/admin")) {
    role = "ADMIN";
  } else if (pathname.startsWith("/client")) {
    role = "CLIENT";
  } else if (pathname.startsWith("/employee")) {
    role = "EMPLOYEE";
  } else if (pathname.startsWith("/candidate")) {
    role = "CANDIDATE";
  }

  if (token) {
    config.headers["Authorization"] = `Bearer ${token}`;
  }
  if (role) {
    config.headers["X-Role"] = role;
  }
  if (email) {
    config.headers["X-User"] = email;
  }
  if (userName) {
    config.headers["X-User-Name"] = userName;
  }
  const envUrl =
    environment.apiUrl ||
    (typeof window !== "undefined" &&
      window.location &&
      window.location.origin) ||
    "";
  if (envUrl) {
    config.headers["X-Environment-Url"] = envUrl;
  }
  return config;
});

/**
 * Send a chat message and get a response from the AI assistant.
 *
 * @param {string} message      - User's message text
 * @param {string|null} sessionId - Existing session ID (null for new session)
 * @returns {Promise<{ response: string, session_id: string, guardrail_triggered: boolean }>}
 */
export async function sendMessage(message, sessionId = null) {
  const payload = { message };
  if (sessionId) payload.session_id = sessionId;

  const res = await chatbotAxios.post("/api/chatbot/chat", payload);
  return res.data;
}

/**
 * Fetch the conversation history for an existing session.
 *
 * @param {string} sessionId
 * @returns {Promise<{ session_id: string, conversation_history: Array }>}
 */
export async function getSessionHistory(sessionId) {
  const res = await chatbotAxios.get(
    `/api/chatbot/session/${sessionId}/history`,
  );
  return res.data;
}
